import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchYears } from "../yearApi";

const YearContext = createContext();

export const YearProvider = ({ children }) => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadYears = async () => {
      try {
        const data = await fetchYears();
        setYears(data);

        const saved = localStorage.getItem("selectedYear");

        if (saved) {
          setSelectedYear(JSON.parse(saved));
        } else if (data.length > 0) {
          setSelectedYear(data[0]);
          localStorage.setItem("selectedYear", JSON.stringify(data[0]));
        }
      } catch (err) {
        console.error("Year load error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadYears();
  }, []);

  const changeYear = (year) => {
    setSelectedYear(year);
    localStorage.setItem("selectedYear", JSON.stringify(year));
  };

  return (
    <YearContext.Provider
      value={{
        years,
        selectedYear,
        changeYear,
        loading,
      }}
    >
      {children}
    </YearContext.Provider>
  );
};

export const useYear = () => useContext(YearContext);



// // src/context/YearContext.js
// import React, { createContext, useContext, useEffect, useState } from "react";

// import { fetchYears } from "../yearApi";

// const YearContext = createContext();

// export const YearProvider = ({ children }) => {
//   const [years, setYears] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const loadYears = async () => {
//       try {
//         const data = await fetchYears();
//         setYears(data);

//         const saved = localStorage.getItem("selectedYear");

//         if (saved) {
//           setSelectedYear(JSON.parse(saved));
//         } else if (data.length > 0) {
//           setSelectedYear(data[0]); // latest year (because ordered desc)
//           localStorage.setItem("selectedYear", JSON.stringify(data[0]));
//         }
//       } catch (err) {
//         console.error("Year load error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadYears();
//   }, []);

//   const changeYear = (year) => {
//     setSelectedYear(year);
//     localStorage.setItem("selectedYear", JSON.stringify(year));
//   };

//   return (
//     <YearContext.Provider
//       value={{
//         years,
//         selectedYear,
//         changeYear,
//         loading,
//       }}
//     >
//       {children}
//     </YearContext.Provider>
//   );
// };

// export const useYear = () => useContext(YearContext);